import type { VehicleDraft } from './types';

export type VehicleValidationResult = {
  isValid: boolean;
  errors: Record<Exclude<keyof VehicleDraft, 'id'>, string | null>;
};

const EMPTY: VehicleValidationResult = {
  isValid: true,
  errors: {
    customerId: null,
    plate: null,
    brand: null,
    model: null,
    year: null,
    vin: null,
    color: null,
    mileage: null,
    notes: null,
  },
};

function validateYear(yearStr: string): string | null {
  if (!yearStr.trim()) return null;
  const year = Number(yearStr);
  if (!Number.isInteger(year)) return 'El año debe ser un número';
  const current = new Date().getFullYear();
  if (year < 1900 || year > current + 1) return `El año debe estar entre 1900 y ${current + 1}`;
  return null;
}

function validateMileage(mileageStr: string): string | null {
  if (!mileageStr.trim()) return null;
  const km = Number(mileageStr);
  if (!Number.isFinite(km) || km < 0) return 'El kilometraje debe ser un número positivo';
  return null;
}

export function validateVehicleDraft(draft: VehicleDraft): VehicleValidationResult {
  const errors = { ...EMPTY.errors };
  let isValid = true;

  const yearErr = validateYear(draft.year);
  if (yearErr) { errors.year = yearErr; isValid = false; }

  const mileageErr = validateMileage(draft.mileage);
  if (mileageErr) { errors.mileage = mileageErr; isValid = false; }

  if (draft.plate.length > 20) { errors.plate = 'La patente no puede superar 20 caracteres'; isValid = false; }
  if (draft.brand.length > 80) { errors.brand = 'La marca no puede superar 80 caracteres'; isValid = false; }
  if (draft.model.length > 120) { errors.model = 'El modelo no puede superar 120 caracteres'; isValid = false; }
  if (draft.vin.length > 50) { errors.vin = 'El VIN no puede superar 50 caracteres'; isValid = false; }
  if (draft.notes.length > 1000) { errors.notes = 'Las notas no pueden superar 1000 caracteres'; isValid = false; }

  return { isValid, errors };
}
